/**
 * @fileoverview CSS module for styling downloadable content sections with icons and text
 *
 * @example
 * // Usage in component:
 * import styles from './Downloadable.module.css';
 *
 * <ul className={styles.list}>
 *   <li>
 *     <img className={styles.list_icon} src="icon.svg" alt="Download icon"/>
 *     <span className={styles.text}>Download item</span>
 *   </li>
 * </ul>
 */


.list {
    list-style-type: none;
    line-height: 2em;
    padding: 0;
    margin: 4px 0 0;
}

.list li {
    display: flex;
    align-items: center;
    padding-bottom: 16px;
    line-height: 24px;
    color: var(--neutural900);
}

.list li:last-of-type {
    padding-bottom: 0px;
}

.list_icon {
    object-fit: none;
    object-position: 0px 0px;
    width: 32px;
    height: 32px;
}

.text {
    padding-left: 16px;
}
